/**
 * @fileoverview Sentry init — production error tracking
 * DSN boşsa veya DEV modundaysa init çalışmaz.
 * Sentry paketi kritik render yoluna girmemesi için dinamik yüklenir.
 */

import { ENV } from './env'

let sentryModulePromise = null

function getSentry() {
  if (!sentryModulePromise) {
    sentryModulePromise = import('@sentry/react')
  }
  return sentryModulePromise
}

/**
 * Sentry'yi başlatır. Sadece PROD + DSN mevcutsa aktif olur.
 * @returns {void}
 */
export const initSentry = () => {
  if (!ENV.SENTRY_DSN || ENV.IS_DEV) {
    if (ENV.IS_DEV) {
      console.info('[Sentry] DEV modunda devre dışı.')
    }
    return
  }

  const boot = async () => {
    const Sentry = await getSentry()
    Sentry.init({
      dsn: ENV.SENTRY_DSN,
      environment: ENV.APP_ENV,
      release: `${ENV.APP_NAME}@1.0.0`,
      tracesSampleRate: 0.2,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllText: false,
          blockAllMedia: false,
        }),
      ],
    })
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => { void boot() }, { timeout: 2500 })
  } else {
    setTimeout(() => { void boot() }, 1500)
  }
}

/**
 * Sentry'ye manuel hata gönder.
 * ErrorBoundary ve async thunk'larda kullanılır.
 * @param {Error} error
 * @param {{ [key: string]: unknown }} [extra]
 */
export const captureError = (error, extra) => {
  if (ENV.IS_DEV) {
    console.error('[Sentry:captureError]', error, extra)
    return
  }
  void getSentry().then((Sentry) => {
    Sentry.captureException(error, { extra })
  })
}
